import firebase from 'firebase/app'
import 'firebase/firestore'

// Get a Firestore instance
const firebaseConfig = {
  apiKey: process.env.VUE_APP_GOOGLE_APIKEY,
  authDomain: process.env.VUE_APP_GOOGLE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_GOOGLE_DATABASE_URL,
  projectId: process.env.VUE_APP_GOOGLE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_GOOGLE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_GOOGLE_SENDER_ID,
  appId: process.env.VUE_APP_GOOGLE_APP_ID
}
export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore()